/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { SVGIcons } from "cms/icons/svg-icons";
import { isTrue } from "utils/empty-exists";

const ListLink = (props) => {
    
    const { link } = props;
    const { url, is_external, text } = link || {};
    const target = is_external ? "_blank" : "_self";
    const is_external_class = is_external ? "is_external" : "";
    
    // TODO: link styles not implemented
    
    return (
        <Fragment>
            {link &&
                <a
                    className='image-list-link'
                    href={url}
                    target={target}
                >
                    <span className={`image_list_link_text ${is_external_class}`}>
                        {text} {isTrue(is_external) && <SVGIcons.fields.LinkField />}
                    </span>
                </a>
            }
        </Fragment>
    );
};

export { ListLink };
